<template>
<div>
    <div class="summary-close-position" v-for = "(item, index) in getClosePair" :key="index" 
        v-if="(index != 'USDRUB') & (index != 'ETHUSD') & (index != 'EURJPY') & (index != 'AUDUSD') & (index != 'NZDUSD')">
        <div class="compare-pairs">
            <div class="title-pair">{{index}}</div>
            <div class="deal-counter">{{item.Count}}</div>
            <div class="deal-percent">({{Math.ceil(item.CountProfit * 100 / item.Count)}}%)</div>
        </div>
        <div :style="{width: (Math.ceil(item.CountProfit * 100 / item.Count))*1.3 + 'px',
            background: colors[index]}" class="bar-deals"></div>
    </div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            colors:{EURGBP:'#ffad66', EURUSD:'#41e6ff', GBPUSD:'#00ffd0', USDCAD:'#ecff24', USDCHF:'#a7aeff', USDJPY:'#ff79e2'}
        }
    },
    props: {
        symbol:{default:''}
    },
    computed: {
        ...mapGetters({
            getSummary: 'closSummary/getSummary'
        }),
        getClosePair() {
            return this.getSummary.SumBySymbol
        },
    },
    created() {
        this.$store.dispatch("closSummary/initialize")
    }
}
</script>
<style lang="less">
.compare-pairs {
    display: flex;
}
.title-pair {
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.82;
    letter-spacing: 0.4px;
    margin-right: 4px;
}

.deal-counter {
    font-family: Arimo;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.82;
    letter-spacing: 0.4px;
    color:#aabed2;
    margin-right: 4px;
}

.deal-percent {
    font-family: Arimo;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.82;
    letter-spacing: 0.4px;
    color:#aabed2
}

.bar-deals {
    background:#000;
    height: 2px;
    display: block;
}
</style>

